export enum UserCategory {
  /** 系統主帳號 */
  SystemAccount = 0,
  /** 系統子帳號 */
  SystemSubAccount = 1,
  /** 系統商主帳號 */
  ProviderAccount = 10,
  /** 系統商子帳號 */
  ProviderSubAccount = 11,
  /** 營運商主帳號 */
  OperatorAccount = 20,
  /** 營運商子帳號 */
  OperatorSubAccount = 21,
  /** 商戶主帳號 */
  TenantAccount = 30,
  /** 商戶子帳號 */
  TenantSubAccount = 31,
  /** 會員帳號 */
  MemberAccount = 40,
  /** 承兌商帳號 */
  DealerAccount = 50,
}

export enum UserPermission {
  // 顯示選單項目：（營運商）會員代收紀錄
  show_menu_operator_reports_member_deposit_records = "show_menu_operator_reports_member_deposit_records",
  // 顯示選單項目：（營運商）會員代付紀錄
  show_menu_operator_reports_member_withdraw_records = "show_menu_operator_reports_member_withdraw_records",
  // 顯示選單項目：（營運商）商戶存單紀錄
  show_menu_operator_reports_deposit_records = "show_menu_operator_reports_deposit_records",
  // 顯示選單項目：（營運商）商戶提單紀錄
  show_menu_operator_reports_withdraw_records = "show_menu_operator_reports_withdraw_records",
  // 顯示選單項目：（營運商）上存紀錄
  show_menu_operator_reports_self_deposit_records = "show_menu_operator_reports_self_deposit_records",
  // 顯示選單項目：（營運商）下發紀錄
  show_menu_operator_reports_self_withdraw_records = "show_menu_operator_reports_self_withdraw_records",

  // 顯示選單項目：系統管理 > 錢包管理
  show_menu_operator_managements_wallets = "show_menu_operator_managements_wallets",
  // 顯示選單項目：系統管理 > 商戶管理
  show_menu_operator_managements_tenants = "show_menu_operator_managements_wallets",
  // 顯示選單項目：系統管理 > 系統設定
  show_menu_operator_managements_options = "show_menu_operator_managements_options",
  // 顯示選單項目：系統管理 > 操作紀錄
  show_menu_operator_managements_operations = "show_menu_operator_managements_operations",

  // 顯示選單項目：（商戶）會員代收紀錄
  show_menu_tenant_reports_member_deposit_records = "show_menu_tenant_reports_member_deposit_records",
  // 顯示選單項目：（商戶）會員代付紀錄
  show_menu_tenant_reports_member_withdraw_records = "show_menu_tenant_reports_member_withdraw_records",
  // 顯示選單項目：（商戶）上存紀錄
  show_menu_tenant_reports_self_deposit_records = "show_menu_tenant_reports_self_deposit_records",
  // 顯示選單項目：（商戶）下發紀錄
  show_menu_tenant_reports_self_withdraw_records = "show_menu_tenant_reports_self_withdraw_records",
  // 顯示選單項目：（商戶）代收日報表
  show_menu_tenant_reports_daily_deposit_records = "show_menu_tenant_reports_daily_deposit_records",
  // 顯示選單項目：（商戶）代付日報表
  show_menu_tenant_reports_daily_withdraw_records = "show_menu_tenant_reports_daily_withdraw_records",
  // 顯示選單項目：（商戶）流水紀錄
  show_menu_tenant_reports_transfers = "show_menu_tenant_reports_transfers",

  // 對應顯示平台管理 > 申請會員代付
  show_menu_tenant_management_create_member_withdraw = "show_menu_tenant_management_create_member_withdraw",
  // 對應顯示平台管理 > 申請會員代收
  show_menu_tenant_management_create_member_deposit = "show_menu_tenant_management_create_member_deposit",
  // 對應顯示平台管理 > 申請人工加分
  show_menu_tenant_management_create_custom_deposit = "show_menu_tenant_management_create_custom_deposit",
  // 對應顯示平台管理 > 申請人工減分
  show_menu_tenant_management_create_custom_withdraw = "show_menu_tenant_management_create_custom_withdraw",
  // 顯示選單項目：平台管理 > 會員管理
  show_menu_tenant_managements_members = "show_menu_tenant_managements_members",
  // 顯示選單項目：平台管理 > 平台設定
  show_menu_tenant_managements_options = "show_menu_tenant_managements_options",
  // 顯示選單項目：平台管理 > 操作紀錄
  show_menu_tenant_managements_operations = "show_menu_tenant_managements_operations",

  // 允許操作：作廢會員代收
  allow_to_cancel_member_deposit_records = "allow_to_cancel_member_deposit_records",
  // 允許操作：作廢會員代付
  allow_to_cancel_member_withdraw_records = "allow_to_cancel_member_withdraw_records",
  // 允許操作：檢核會員代收
  allow_to_check_member_deposit_records = "allow_to_check_member_deposit_records",
  // 允許操作：檢核會員代付
  allow_to_check_member_withdraw_records = "allow_to_check_member_withdraw_records",
  // 允許操作：還原會員存單（狀態為已拒絕）
  allow_to_recover_member_deposit_records_when_status_is_refused = "allow_to_recover_member_deposit_records_when_status_is_refused",
  // 允許操作：還原會員提單（狀態為已轉帳且交易哈希為空值超過 1 分鐘）
  allow_to_recover_member_withdraw_records_when_status_is_transed_and_transaction_is_null_over_1_mins = "allow_to_recover_member_withdraw_records_when_status_is_transed_and_transaction_is_null_over_1_mins",
  // 允許操作：還原會員提單（狀態為已轉帳且交易哈希為空值超過 3 分鐘）
  allow_to_recover_member_withdraw_records_when_status_is_transed_and_transaction_is_null_over_3_mins = "allow_to_recover_member_withdraw_records_when_status_is_transed_and_transaction_is_null_over_3_mins",

  // 允許操作：申請會員代收時修改存單金額
  allow_to_change_amount_when_tenant_management_create_member_deposit = "allow_to_change_amount_when_tenant_management_create_member_deposit",
  // 允許操作：申請會員代收時修改提單金額
  allow_to_change_amount_when_tenant_management_create_member_withdraw = "allow_to_change_amount_when_tenant_management_create_member_withdraw",
}

export enum UserStatus {
  disabled = 0,
  enabled = 1,
}

export enum UserOptionMemberChargeFrom {
  /** 從商戶 */
  Tenant = 0,
  /** 從會員 */
  Member = 1,
}

export enum UserOptionMemberChargeTime {
  /** 成立時 */
  Verified = 0,
  /** 對帳時 */
  Reported = 1,
}
